export default __webpack_public_path__ + "static/media/logo.8ff4bdc0.png";